import React from 'react';
import { signOutAction } from '@/app/actions/signOutAction';

const LogoutIconSvg = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 17L21 12M21 12L16 7M21 12H9M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface LogoutIconProps {
  isBackgroundWhite: boolean;
  onClick?: () => void;
}

export default function LogoutIcon({
  isBackgroundWhite,
  onClick,
}: LogoutIconProps): React.ReactElement {
  const handleFormAction = async (_formData: FormData) => {
    // Clear session storage before server action
    if (typeof window !== 'undefined') {
      sessionStorage.clear();
    }

    // Call optional onClick prop if provided
    if (onClick) {
      onClick();
    }

    // Execute server action
    await signOutAction();
  };

  return (
    <form
      action={handleFormAction}
      className="flex items-center justify-center"
    >
      <button
        type="submit"
        aria-label="Sign out"
        className="group cursor-pointer"
      >
        <div className="relative transition-all duration-300 ease-in-out group-hover:scale-110">
          <div className="absolute inset-0 scale-150 transform rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
          <LogoutIconSvg
            className={`relative z-10 transition-colors duration-300 ease-in-out ${
              isBackgroundWhite
                ? 'text-black group-hover:text-[#8875D5]'
                : 'text-white group-hover:text-[#C3B5FF]'
            }`}
          />
        </div>
      </button>
    </form>
  );
}
